import { atom } from 'jotai';

const globalMatomoAtom = atom({ id: '', url: '' });

export { globalMatomoAtom };